import { render, staticRenderFns } from "./PubAPITransTblAction.vue?vue&type=template&id=0fc6fb6e&"
import script from "./PubAPITransTblAction.vue?vue&type=script&lang=js&"
export * from "./PubAPITransTblAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports